module.exports = {
  selectLanguage: 'Select your language',
}



// WEBPACK FOOTER //
// ./src/data/messages/en.js